export default "__VITE_ASSET__C3hjE9LI__"